import 'react';
import '../types/props.js';
import { css, keyframes } from 'reakit/styled';
import { palette, theme } from 'styled-tools';
import 'styled-selector';
import selector from '../styled/selector.js';
import 'lodash/get';
import space from '../styled/space.js';
import styled from '../styled/index.js';
import '../chunk-ad6ad343.js';
import 'polished';
import '../default/palette.js';
import 'reakit/Button';
import 'airbnb-prop-types';
import '../parseIcons.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import Flex from 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import { a as Icon } from '../chunk-16546651.js';
import '../Set/styled.js';
import '../Set/index.js';
import '../Button/styled.js';
import '../Spinner/styled.js';
import '../Spinner/index.js';
import '../chunk-68945c57.js';
import 'lodash/omit';
import '../Button/ActionButtons.js';
import Button from '../Button/index.js';
import 'classnames';
import 'reakit/Heading';
import '../Heading/styled.js';
import Heading from '../Heading/index.js';
import '../Pane/styled.js';
import '../chunk-895bf8c9.js';
import Pane from '../Pane/index.js';
var ToastClose = styled(Button).withConfig({
  displayName: "styled__ToastClose",
  componentId: "cax10c-0"
})(["width:24px;min-height:24px;padding:0;text-align:right;", ";&:hover{background-color:", ";&{", ";}}&{", ";}"], function (props) {
  return props.isAbsolute ? css(["position:absolute;right:", "rem;top:", "rem;"], space(2), space(2)) : css(["margin:0 ", "rem;"], space(2));
}, palette('white700'), theme('fannypack.Toast.Close.hover'), theme('fannypack.Toast.Close.base'));
var ToastTitle = styled(Heading).withConfig({
  displayName: "styled__ToastTitle",
  componentId: "cax10c-1"
})(["&{", ";}"], theme('fannypack.Toast.Title.base'));
var ToastIconWrapper = styled(Flex).withConfig({
  displayName: "styled__ToastIconWrapper",
  componentId: "cax10c-2"
})(["margin-right:", "rem;margin-left:-", "rem;align-items:center;&{", ";}"], space(3), space(1), theme('fannypack.Toast.Icon.wrapper'));
var ToastIcon = styled(Icon).withConfig({
  displayName: "styled__ToastIcon",
  componentId: "cax10c-3"
})(["&{", ";}"], theme('fannypack.Toast.Icon.base'));
var Content = styled(Flex).withConfig({
  displayName: "styled__Content",
  componentId: "cax10c-4"
})(["padding:", "rem;padding-right:", "rem;", ";&{", ";}"], space(4), space(8), function (props) {
  return props.showCountdownBar ? css(["padding-left:calc(", "rem + 5px);"], space(4)) : css(["padding-left:", "rem;"], space(4));
}, theme('fannypack.Toast.Content.base'));
var heightCountdown = keyframes(["from{height:calc(100% + 2px);}to{height:0%;}"]);
var widthCountdown = keyframes(["from{width:calc(100% + 2px);}to{width:0%;}"]);
var CountdownBar = styled(Box).withConfig({
  displayName: "styled__CountdownBar",
  componentId: "cax10c-5"
})(["position:absolute;", ";", ";", ";", ";&{", ";}"], function (props) {
  return props.isHorizontal ? css(["border-bottom-right-radius:3px;border-bottom-left-radius:3px;bottom:0;height:5px;right:-1px;width:calc(100% + 2px);"]) : css(["border-top-left-radius:3px;border-bottom-left-radius:3px;bottom:-1px;height:calc(100% + 2px);margin-left:-1px;width:5px;"]);
}, function (props) {
  return props.type && css(["background-color:", ";"], props.isBackground ? palette(props.type + "Tint") : palette(props.type));
}, function (props) {
  return props.autoDismissTimeout && css(["", ";&{", ";}"], function (props) {
    return props.isHorizontal ? css(["animation:", " ", "ms linear forwards;border-bottom-left-radius:unset;"], widthCountdown, props.autoDismissTimeout) : css(["animation:", " ", "ms linear forwards;border-top-left-radius:unset;"], heightCountdown, props.autoDismissTimeout);
  }, theme('fannypack.Toast.CountdownBar.autoDismissTimeout'));
}, function (props) {
  return props.isBackground && css(["&{", ";}"], theme('fannypack.Toast.CountdownBar.background'));
}, theme('fannypack.Toast.CountdownBar.base'));
var tintAttributes = css(["background-color:", ";color:", ";fill:", ";", ";"], function (props) {
  return props.type && palette(props.type + "Tint")(props);
}, function (props) {
  return props.type && palette(props.type + "TintInverted")(props);
}, function (props) {
  return props.type && palette(props.type + "TintInverted")(props);
}, theme('fannypack.Toast.tint'));
var Toast = styled(Pane).withConfig({
  displayName: "styled__Toast",
  componentId: "cax10c-6"
})(["align-items:center;display:flex;font-size:", "rem;justify-content:space-between;position:relative;width:350px;&:not(:last-child){margin-bottom:", "rem;}&{", ";}&{", ";}"], theme('fannypack.fontSizes.150'), space(4), function (props) {
  return props.hasTint && tintAttributes;
}, theme('fannypack.Toast.base'));
var fromLeft = keyframes(["from{transform:translateX(-120%);}to{transform:translateX(0);}"]);
var fromRight = keyframes(["from{transform:translateX(120%);}to{transform:translateX(0);}"]);
var fromTop = keyframes(["from{transform:translateY(-120%);}to{transform:translateY(0);}"]);
var fromBottom = keyframes(["from{transform:translateY(120%);}to{transform:translateY(0);}"]);
var placementAttributes = {
  'top-start': css(["top:1rem;left:1rem;& ", "{animation:", " 300ms ease-in-out forwards;}"], selector(Toast), fromLeft),
  top: css(["top:1rem;left:50%;transform:translateX(-50%);& ", "{animation:", " 300ms ease-in-out forwards;}"], selector(Toast), fromTop),
  'top-end': css(["top:1rem;right:1rem;& ", "{animation:", " 300ms ease-in-out forwards;}"], selector(Toast), fromRight),
  left: css(["left:1rem;top:50%;transform:translateY(-50%);& ", "{animation:", " 300ms ease-in-out forwards;}"], selector(Toast), fromLeft),
  right: css(["right:1rem;top:50%;transform:translateY(-50%);& ", "{animation:", " 300ms ease-in-out forwards;}"], selector(Toast), fromRight),
  'bottom-start': css(["bottom:1rem;left:1rem;& ", "{animation:", " 300ms ease-in-out forwards;}"], selector(Toast), fromLeft),
  bottom: css(["bottom:1rem;left:50%;transform:translateX(-50%);& ", "{animation:", " 300ms ease-in-out forwards;}"], selector(Toast), fromBottom),
  'bottom-end': css(["bottom:1rem;right:1rem;& ", "{animation:", " 300ms ease-in-out forwards;}"], selector(Toast), fromRight)
};
var Toasts = styled(Box).withConfig({
  displayName: "styled__Toasts",
  componentId: "cax10c-7"
})(["position:fixed;z-index:99999;", ";&{", ";}"], function (props) {
  return placementAttributes[props.placement];
}, theme('fannypack.Toasts.base'));
export default Toast;
export { Content, CountdownBar, Toast, ToastClose, ToastIcon, ToastIconWrapper, ToastTitle, Toasts, heightCountdown, placementAttributes, widthCountdown };